import { useSuspenseQuery } from '@tanstack/react-query';
import api from '../Role/api';

export const useRoleQuery = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchAllRole'],
    queryFn: () => {
      return api.getManyRole();
    },
  });
  return data;
};
